// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "index" + "." + "62df8f1937c51d447be2" + ".css";
};